<template>
<div class="pb-3">
    <Slider :items="sliderItems" :interval="3000" />
    <article class="d-flex flex-wrap flex-row px-2 mx-1">
    <GenresList 
    v-for="(genre, index) in genres"
    :key="index"
    :item="genre"/>
    </article>
</div>
</template>


<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex';
import Slider from '@/components/Slider.vue'
import GenresList from '@/components/GenresList.vue'
export default {
    name: 'Genres',
    components: {
    Slider,
    GenresList
  },
  computed: {
    ...mapGetters({
        genres: 'productCatalog/genres'
    }),
    sliderItems: function () {
      return this.sliders().map((value, index) => {
        return {
          isMain: index === 0,
          src: value.image,
          targetUrl: value.targetUrl
        }
      })
    }
  },
  mounted () {
    if (this.sliderItems.length === 0) {
      this.loadSliders()
    }
  },
  methods: {
    ...mapActions({
      loadSliders: 'productCatalog/loadSliders',
      loadGenres: 'productCatalog/loadGenres'
    }),
    ...mapGetters({
      sliders: 'productCatalog/sliders'
    })
  },
  created() {
    if (this.genres.length === 0) {
      this.loadGenres()
    }
  }
}
</script>